import $ from 'jquery'

/**
 * ------------------------------------------------------------------------
 * Constants
 * ------------------------------------------------------------------------
 */

const NAME = 'wrapper'
const DATA_KEY = `opp.${NAME}`

const Selector = {
  NOBS: '.nobs',
  // N.B. opt-out by adding `data-scope="none"` attribute to `style` tag.
  NOBS_LINK_STYLE: '[data-scope="nobs"], .nobs style:not([data-scope="none"])'
}

const Pattern = {
  SPLIT: /,\s*/,
  // - html and body cannot be scoped
  // - ids do not need to be scoped
  // - skip already scoped selectors
  SKIP: /(?:^:root|#|\.ui-[a-z]|\.nobs )/
}

/**
 * ------------------------------------------------------------------------
 * Class Definition
 * ------------------------------------------------------------------------
 */

class Wrapper {
  constructor(element) {
    this._element = element
    this._supported = this._isSupported()
    this._wrapperElements = this._getWrapperElements()
    this._linkStyleElements = this._getLinkStyleElements()

    $(window).on('load', () => this.show())
  }

  // Public

  show() {
    // Process each link/style element in document order.
    for (const elem of this._linkStyleElements) {
      this._processLinkStyleElement(elem)
    }

    // Show each wrapper element, if collapsed.
    $(this._wrapperElements).collapse('show')
  }

  // Private

  _isSupported() {
    return 'CSSStyleSheet' in window && 'insertRule' in CSSStyleSheet.prototype
  }

  // Apply '.nobs' scope to each selector in the `selText`
  _scopeSelector(selText) {
    return selText.split(Pattern.SPLIT).map(sel => {
      return Pattern.SKIP.test(sel) ? sel : `${Selector.NOBS} ${sel}`
    }).join(', ')
  }

  _getWrapperElements() {
    return this._element.querySelectorAll(Selector.NOBS)
  }

  _getLinkStyleElements() {
    return this._element.querySelectorAll(Selector.NOBS_LINK_STYLE)
  }

  _processLinkStyleElement(elem) {
    // If not supported, use CSS as is and hoe for the best. N.B. If media
    // property is 'print' we need to change it to apply the stylesheet.
    if (!this._supported && elem.media === 'print') {
      elem.media = 'all'
      return
    }

    // Skip if element does not have a StyleSheet.
    if (!elem.sheet) {
      return
    }

    // Create new style element and add to DOM to init sheet property.
    const style = document.createElement('style')
    document.head.appendChild(style)

    // Disable new style element until ready.
    style.disabled = true

    // Copy type property, if present
    if (elem.type) {
      style.type = elem.type
    }

    // Copy media property, if applicable. N.B. ignore 'print' which is added so
    // that nobs "scoped" stylesheets can be loaded asynchronously and modified
    // before they are applied.
    if (elem.media && elem.media !== 'print') {
      style.media = elem.media
    }

    // N.B. Also support deprecated "rules" prop property.
    const cssRules = elem.sheet.cssRules || elem.sheet.rules
    const cssRulesLength = cssRules.length

    // Copy each rule to new sheet.
    for (let i = 0; i < cssRulesLength; i++) {
      const { cssText: _cssText, selectorText } = cssRules[i]

      // Use as-is by defualt.
      let cssText = _cssText

      // Scope selector text, if present.
      if (selectorText) {
        const styleText = cssText.slice(selectorText.length)
        cssText = this._scopeSelector(selectorText) + styleText
      }

      // Copy to new sheet.
      style.sheet.insertRule(cssText, i)
    }

    // Enable the new style element.
    style.disabled = false

    // Remove original element.
    $(elem).remove()
  }

  // Static

  static init() {
    let data = $(document).data(DATA_KEY)
    if (!data) {
      data = new Wrapper(document)
      $(document).data(DATA_KEY, data)
    }
  }
}

export default Wrapper
